import {Top} from "./Top";

require('./bootstrap');

import {Nav} from "./Nav";
import {Tab} from "./Tab";
import FastClick from 'fastclick';
import SmoothScroll from 'smooth-scroll';
import {Opener} from "./Opener";
import {MapResult} from "./MapResult";
import {DatetimePicker} from "../admin/DatetimePicker";
import {LockPage} from "./LockPage";

class App {


  constructor() {

    var ua = navigator.userAgent;
    var sp = (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0);
    var tab = (!sp && (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0));
    var ie11 = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;
    if(ie11){
      $('body').addClass('ie11');
    }
    if (!tab) {
      var agent = window.navigator.userAgent.toLowerCase();
      var ipad = agent.indexOf('ipad') > -1 || agent.indexOf('macintosh') > -1 && 'ontouchend' in document;
      if (ipad == true) {
        tab = true;
      }
    }

    window.isSP = sp;
    if (window.isSP) {
      var touch = 'ontouchstart' in document.documentElement
        || navigator.maxTouchPoints > 0
        || navigator.msMaxTouchPoints > 0;
      if (touch) { // remove all :hover stylesheets
        try { // prevent exception on browsers not supporting DOM styleSheets properly
          for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;
            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
              if (!styleSheet.rules[ri].selectorText) continue;
              if (styleSheet.rules[ri].selectorText.match(':hover')) {
                styleSheet.deleteRule(ri);
              }
            }
          }
        } catch (ex) {

        }
      }
    }


    // FastClick.attach(document.body);


    this.scrollOffset = $('.header').height();
    var scroll = new SmoothScroll('a[href*="#"]', {
      speed: 1000,
      speedAsDuration: true,
      offset: (anchor, toggle) => {
        return this.scrollOffset;
      }
    });

    window.s = new SmoothScroll();


    if (location.hash != "") {
      window.addEventListener('load',function(){
        $("html, body").animate({scrollTop: $(location.hash).offset().top - $('.header').height()-20 }, 500);  
      });
    }

    var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
    $('[data-role=autolink]').each(function (e) {
      var $tar = $(this);
      $tar.html($tar.html().replace(exp, "<a target='_blank' href='$1'>$1</a>"));
    });

    new Nav(this);
    new Tab(this);
    new Opener(this);
    new DatetimePicker();
    new LockPage();


  }

  initTop() {
    new Top()
  }

  initMapResult() {
    new MapResult()
  }
}


window.app = new App();